<template>
  <div>
    <Label v-if="label">{{ label }}</Label>
    <select
      v-model="selectedOption"
      :disabled="disabled"
      class="block w-full rounded-md border-0 bg-white py-1.5 pl-1.5 pr-7 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-500 disabled:ring-gray-200 sm:pl-3 sm:text-sm sm:leading-6"
    >
      <option v-if="placeholder" disabled selected>
        {{ placeholder }}
      </option>
      <option
        v-for="option in options"
        :key="option"
        :value="option"
        :selected="selectedOption === option"
      >
        {{ getDisplayName(option) }}
      </option>
    </select>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  modelValue: {
    type: String,
    required: true,
  },
  options: {
    type: Array as PropType<string[]>,
    required: true,
  },
  label: {
    type: String,
    default: undefined,
  },
  placeholder: {
    type: String,
    default: undefined,
  },
  getDisplayName: {
    type: Function,
    default: (option: string) => option,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:modelValue']);

const selectedOption = computed({
  get: () => props.modelValue || props.placeholder,
  set: (value) => emit('update:modelValue', value),
});
</script>
